// Painel colapsável para resposta intermediária de um subagent.
// Estilo similar ao ReasoningPanel — usuário pode abrir pra ver o que cada
// member do team falou antes do supervisor consolidar.

import { useState } from 'preact/hooks';
import { Markdown } from './Markdown';

interface Props {
  agent: string;
  content: string;
}

export function SubagentPanel({ agent, content }: Props) {
  const [open, setOpen] = useState(false);
  if (!content) return null;

  const charCount = content.length;

  return (
    <div class="border border-border rounded-md bg-muted/30">
      <button
        class="w-full flex items-center gap-2 px-3 py-2 text-xs hover:bg-muted/50 rounded-md focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
        onClick={() => setOpen(!open)}
      >
        <i class={`ph ${open ? 'ph-caret-down' : 'ph-caret-right'} text-sm text-muted-foreground`} />
        <i class="ph ph-user text-sm text-muted-foreground" />
        <span class="font-medium text-muted-foreground">
          {agent} <span class="font-mono tabular-nums text-[10px]">· {charCount} chars</span>
        </span>
      </button>
      {open && (
        <div class="px-3 pb-3 pt-1 border-t border-border text-xs text-muted-foreground">
          <Markdown content={content} />
        </div>
      )}
    </div>
  );
}
